/**
 * A dog as data. Everything that differs between Luna and Tango lives here;
 * the body, behaviours and world code are shared.
 */
export interface DogProfile {
  id: 'luna' | 'tango';
  name: string;
  /** words the recogniser might produce for the name */
  aliases: string[];
  pronoun: 'her' | 'him'; // both dogs are girls
  coat: number;
  mask: number; // muzzle
  ears: number;
  /** overall scale (Luna = 1, a medium dog ~0.6 m at the shoulder) */
  size: number;
  earStyle: 'drop' | 'erect';
  tailStyle: 'curl' | 'short-up';
  /** multiplier on bark pitch */
  barkPitch: number;
  /** subfolder of public/sounds/ with this dog's own clips; falls back to the shared ones */
  sounds: string;
  /** rigged model in public/models/ (from tools/build-dog.mjs) */
  model: string;
}

export const LUNA: DogProfile = {
  id: 'luna',
  name: 'Luna',
  aliases: ['luna', 'lunar', 'tuna', 'luna loo'],
  pronoun: 'her',
  coat: 0xc99a5b,
  mask: 0x2a1a10,
  ears: 0x2a1a10,
  size: 1,
  earStyle: 'drop',
  tailStyle: 'curl',
  barkPitch: 0.95,
  sounds: 'luna',
  model: 'dog-luna',
};

export const TANGO: DogProfile = {
  id: 'tango',
  name: 'Tango',
  aliases: ['tango', 'tengo', 'mango', 'tangle'],
  pronoun: 'her',
  coat: 0xf1ece2,
  mask: 0xe6dfd2,
  ears: 0xe6dfd2,
  size: 0.8,
  earStyle: 'erect',
  tailStyle: 'short-up',
  barkPitch: 1.12,
  sounds: 'tango',
  model: 'dog-tango',
};

export const PROFILES: Record<DogProfile['id'], DogProfile> = { luna: LUNA, tango: TANGO };

const KEY = 'lunaloo.dog';
export function loadProfile(): DogProfile {
  try {
    const id = localStorage.getItem(KEY) as DogProfile['id'] | null;
    if (id && PROFILES[id]) return PROFILES[id];
  } catch {
    /* no storage */
  }
  return LUNA;
}
export function saveProfile(id: DogProfile['id']): void {
  try {
    localStorage.setItem(KEY, id);
  } catch {
    /* no storage */
  }
}
